<template>
  <SVGIconNextVue
    :icon="props.icon"
    :size="computedSize"
    :palette="props.palette"
    :axes="props.axes"
    v-bind="$attrs"
  />
</template>
<script setup lang="ts">
import { computed } from 'vue'
import * as SVGIconNext from '@bilibili/svg-icon-next-vue'

const SVGIconNextVue = SVGIconNext.SVGIconNext

const props = withDefaults(
  defineProps<{
    icon: string
    size?: number | [number, number] | string
    axes?: Record<string, number>
    palette?: string | string[]
  }>(),
  {
    size: 12
  }
)

const computedSize = computed(() => props.size)
</script>
